export var PopUpStatus;
(function (PopUpStatus) {
    PopUpStatus[PopUpStatus["ACTIVE"] = 1] = "ACTIVE";
    PopUpStatus[PopUpStatus["DRAFT"] = 2] = "DRAFT";
    PopUpStatus[PopUpStatus["ARCHIVED"] = 3] = "ARCHIVED";
})(PopUpStatus || (PopUpStatus = {}));
